import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import jwtService from '../../services/jwtService';
import { Translate } from '../../localization';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import { setLoginError, submitLogin } from '../../store/actions/user.actions';

import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { toastr } from 'react-redux-toastr';

import SignUp from '../SignUp';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputUsername: '',
            inputPassword: '',
            newPassword: '',
            inputEmail: '',
            inputOtp: '',
            checked: true,
            usernameError: false,
            emailError: false,
            passwordError: false,
            loginLoading: false,
            pwdType: 'password',
            title: 'Login',
            loading: false,
            showSignUp: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.inputUsername !== this.state.inputUsername) {
            this.props.setLoginError('');

            if (!this.state.inputUsername) {
                this.setState({ usernameError: true });
            } else {
                this.setState({ usernameError: false });
            }
        }

        if (prevState.inputPassword !== this.state.inputPassword) {
            this.props.setLoginError('');

            if (!this.state.inputPassword) {
                this.setState({ passwordError: true });
            } else {
                this.setState({ passwordError: false });
            }
        }
    }

    componentWillUnmount() {
        this.props.setLoginError('');
    }

    stayLoggedIn = (e) => {
        this.setState({ checked: e.target.checked });
    };

    handleSubmit = (e) => {
        if (!this.state.usernameError && !this.state.passwordError) {
            if (this.state.inputUsername.length > 0 && this.state.inputPassword.length > 0) {
                this.setState({ loginLoading: true });
                this.props.submitLogin(this.state.inputUsername, this.state.inputPassword, this.props.history);
            } else {
                if (this.state.inputUsername.length === 0) {
                    this.setState({
                        usernameError: true,
                    });
                }
                if (this.state.inputPassword.length === 0) {
                    this.setState({
                        passwordError: true,
                    });
                }
            }
        }
    };

    getOtp = async (email) => {
        let data = {
            email,
            type: 'forgot-password'
        };
        this.setState({ loading: true });
        try {
            let response = await jwtService.getOtp(data);
            toastr.success(response?.message);
            this.setState({ loading: false });
            this.setState({ title: 'Submit Otp' });
        } catch (error) {
            this.setState({ loading: false });
            if (error.response.data.status === 400 && error.response.data.error === 'Email already exists') {
                toastr.error(error.response.data.error);
            } else {
                toastr.error('Something went wrong');
            }
        }
    }

    handleForgotPassword = () => {
        let { inputEmail } = this.state;
        if (inputEmail.length == 0) {
            this.setState({ emailError: 'required' });
        } else if (!inputEmail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            this.setState({ emailError: 'please valid email formate' });
        } else {
            this.getOtp(inputEmail);
        }
    };

    handleOtpSubmit = () => {
        this.verifyOtp(this.state.inputOtp, this.state.inputEmail);
    }

    verifyOtp = async (otp, email) => {
        let data = {
            otp,
            email
        };
        this.setState({ loading: true });
        try {
            let response = await jwtService.verifyOtp(data);
            toastr.success(response?.message);
            this.setState({ loading: false });
            this.setState({ title: 'Change Password' });
        } catch (error) {
            this.setState({ loading: false });
            if (error.response.data.status === 400 && error.response.data.error === 'Email already exists') {
                toastr.error(error.response.data.error);
            } else {
                toastr.error('Something went wrong');
            }
        }
    }

    handleChangePwdSubmit = () => {
        this.forgotPassword(this.state.inputOtp, this.state.inputEmail, this.state.newPassword);
    }

    forgotPassword = async (otp, email, new_password) => {
        let data = {
            otp,
            email,
            new_password
        };
        this.setState({ loading: true });
        try {
            let response = await jwtService.forgotPassword(data);
            toastr.success(response?.message);
            this.setState({ loading: false });
            this.setState({ title: 'Login' });
        } catch (error) {
            this.setState({ loading: false });
            if (error.response.data.status === 400 && error.response.data.error === 'Email already exists') {
                toastr.error(error.response.data.error);
            } else {
                toastr.error('Something went wrong');
            }
        }
    }

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
            loginLoading: false,
            usernameError: null,
            passwordError: null,
            emailError: null,
        });
    };

    showSignUpForm = (e) => {
        this.setState({ showSignUp: true });
    };

    hideSignUp = () => {
        this.setState({ showSignUp: false });
    };

    render() {
        let { loginError, userData } = this.props;
        let show = userData === null;
        let {
            title,
            usernameError,
            passwordError,
            loginLoading,
            emailError,
            pwdType,
            showSignUp
        } = this.state;        
        return (
            <React.Fragment>
                <Dialog onClose={this.props.hideLogin} aria-labelledby="login-dialog-title" open={show} className="auth__modal login-modal" scroll="body">
                    <DialogTitle id="login-dialog-title" className="custom-modal-header" disableTypography>
                        <div className="dialog-logo-wrap">{title == "Login" ?Translate.login: Translate.forgetPassword}</div>                        
                        <IconButton aria-label="close" className="close-modal" onClick={this.props.hideLogin}>
                            <i className="material-icons text-white fs-22">{Translate.close}</i>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent className="pt-0">
                        {title == 'Login' && <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSubmit();
                            }}
                        >
                            <div className={`mt-1 ${usernameError ? 'auth__error-field' : ''}`}>
                                <label>{Translate.username}</label>
                                <input
                                    type="text"
                                    autoFocus
                                    className="auth__input"
                                    placeholder={Translate.username}
                                    id="inputUsername"
                                    onChange={this.handleChange}
                                    autoComplete="username"
                                />
                                {usernameError && <p className="auth__error sm">{Translate.required}</p>}
                            </div>
                            <div className={`mt-2 ${passwordError ? 'auth__error-field' : ''}`}>
                                <label>{Translate.password}</label>
                                <div className="position-relative">
                                    <input
                                        type={pwdType}
                                        className="auth__input"
                                        placeholder={Translate.password}
                                        id="inputPassword"
                                        onChange={this.handleChange}
                                        autoComplete="current-password"
                                    />
                                    {pwdType == 'password' ? (
                                        <VisibilityIcon
                                            className="icon-position cursor-pointer position-absolute"
                                            onClick={() => this.setState({ pwdType: 'text' })}
                                        />
                                    ) : (
                                        <VisibilityOffIcon
                                            className="icon-position cursor-pointer position-absolute"
                                            onClick={() => this.setState({ pwdType: 'password' })}
                                        />
                                    )}
                                </div>
                            </div>
                            {passwordError && <p className="auth__error sm">{Translate.required}</p>}
                            <div className="fs-13 pt-2" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                <Button onClick={() => this.setState({ title: 'Forgot Password' })}>
                                    {Translate.forgetPassword}
                                </Button>
                            </div>
                            <div className="auth__btn-wrap">
                                {loginError && (
                                    <p className="auth__error auth__error_with-icon md">
                                        <span className="material-icons icon mr-2 align-middle fs-22">error_outline</span>
                                        <span className="d-inline-block align-middle">{loginError}</span>
                                    </p>
                                )}

                                <Button
                                    variant="contained"
                                    className="auth__btn d-flex justify-content-center align-items-center btn-sign-up"
                                    type="submit"
                                    disabled={loginLoading && !loginError}
                                >
                                    {Translate.login}
                                    {loginLoading && !loginError && <LoadingIcon />}
                                </Button>
                            </div>
                            <div className="signup-btn">
                                <Button variant="contained" className="btn d-flex justify-content-center align-items-center btn-login my-2 signup-button" type="button" onClick={this.showSignUpForm}>
                                    {Translate.signup}
                                </Button>
                            </div>
                        </form>}
                        {title == 'Forgot Password' && <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleForgotPassword();
                            }}
                        >
                            <div className={`mt-1 ${emailError ? 'auth__error-field' : ''}`}>
                                <label>{Translate.email}</label>
                                <input
                                    type="text"
                                    autoFocus
                                    className="auth__input"
                                    placeholder={Translate.registeredEmail}
                                    id="inputEmail"
                                    onChange={this.handleChange}
                                    autoComplete="inputEmail"
                                />
                                {emailError && <p className="auth__error sm">{emailError}</p>}
                            </div>
                            <div className="fs-13 pt-2" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                <Button onClick={() => this.setState({ title: 'Login' })}>
                                {Translate.backLogin} 
                                </Button>
                            </div>
                            <div className="auth__btn-wrap">
                                {loginError && (
                                    <p className="auth__error auth__error_with-icon md">
                                        <span className="material-icons icon mr-2 align-middle fs-22">error_outline</span>
                                        <span className="d-inline-block align-middle">{loginError}</span>
                                    </p>
                                )}

                                <Button
                                    variant="contained"
                                    className="auth__btn d-flex justify-content-center align-items-center"
                                    type="submit"
                                >
                                                                    {Translate.sendOTP}                                     
                                </Button>
                            </div>
                        </form>}
                        {title == 'Submit Otp' && <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleOtpSubmit();
                            }}
                        >
                            <div className={`mt-1`}>
                                <label>{Translate.enterOtp}</label>
                                <input
                                    type="text"
                                    autoFocus
                                    className="auth__input"
                                    placeholder={Translate.enterOtp}
                                    id="inputOtp"
                                    onChange={this.handleChange}
                                    autoComplete="otp"
                                />
                            </div>
                            <div className="auth__btn-wrap">
                                {loginError && (
                                    <p className="auth__error auth__error_with-icon md">
                                        <span className="material-icons icon mr-2 align-middle fs-22">error_outline</span>
                                        <span className="d-inline-block align-middle">{loginError}</span>
                                    </p>
                                )}

                                <Button
                                    variant="contained"
                                    className="auth__btn d-flex justify-content-center align-items-center"
                                    type="submit"
                                >
                                    Verify Otp
                                </Button>
                                {/* <Button variant="contained" className="auth__btn sm d-flex justify-content-center align-items-center mt-2" type="button">
                                    {Translate.signup}
                                </Button> */}
                            </div>
                        </form>}
                        {title == 'Change Password' && <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleChangePwdSubmit();
                            }}
                        >
                            <div className={`mt-2`}>
                                <label>{Translate.enterNewPassword}</label>
                                <div className="position-relative">
                                    <input
                                        type={pwdType}
                                        className="auth__input"
                                        placeholder={Translate.enterNewPassword}
                                        id="newPassword"
                                        onChange={this.handleChange}
                                        autoComplete="newPassword"
                                        minLength='6'
                                        maxLength='14'
                                    />
                                    {pwdType == 'password' ? (
                                        <VisibilityIcon
                                            className="icon-position cursor-pointer position-absolute"
                                            onClick={() => this.setState({ pwdType: 'text' })}
                                        />
                                    ) : (
                                        <VisibilityOffIcon
                                            className="icon-position cursor-pointer position-absolute"
                                            onClick={() => this.setState({ pwdType: 'password' })}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="auth__btn-wrap">
                                {loginError && (
                                    <p className="auth__error auth__error_with-icon md">
                                        <span className="material-icons icon mr-2 align-middle fs-22">error_outline</span>
                                        <span className="d-inline-block align-middle">{loginError}</span>
                                    </p>
                                )}

                                <Button
                                    variant="contained"
                                    className="auth__btn d-flex justify-content-center align-items-center"
                                    type="submit"
                                    disabled={loginLoading && !loginError}
                                >
                                    Change Password
                                </Button>
                            </div>
                        </form>}
                    </DialogContent>
                </Dialog>
                {showSignUp && <SignUp hideSignUp={this.hideSignUp} />}
            </React.Fragment>
        );
    }
}

Login.propTypes = {
    userData: PropTypes.object,
    setLoginError: PropTypes.func,
    loginError: PropTypes.string,
    submitLogin: PropTypes.func,
    language: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        loginError: state.user.loginError,
        language: state.general.language,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setLoginError: (error) => dispatch(setLoginError(error)),
        submitLogin: (username, password, rememberMe) => dispatch(submitLogin(username, password, rememberMe)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
